export default "__VITE_ASSET__1bcc93de__"